module.exports = __webpack_public_path__ + "img/aframe.98f1d2c9.gif";